import axios from "axios";
import { log as logger } from "common/utils/Logging";
//Limitless imports
import ClientContext from "common/utils/client-context/ClientContext";
export const getWebSocketURL = (successCallback, errorCallback) => {
  const log = logger.getLogger("WebSocketActions getWebSocketURL");
  const configURL = `${process.env.REACT_APP_BASE_PLATFORM_URL}community/config?name=realtimeendpoint`;
  axios.get(configURL, {
    headers: {
      "x-api-key": ClientContext._apiKey
    }
  }).then(response => {
    log.debug("Successfully retreived web socket URL", response.data.url);
    if (typeof successCallback === "function") {
      successCallback(response.data.url);
    }
  }).catch(error => {
    if (typeof errorCallback === "function") {
      errorCallback(error);
    }
  });
};